export const CACHE_DATABASE = "coachhub-query-cache";
export const CACHE_STORE = "clients";

export function createIndexedDBStorage(factory) {
  let opening;
  let unavailable = false;
  const open = () => {
    if (unavailable) return Promise.reject(new Error("IndexedDB unavailable"));
    if (opening) return opening;
    opening = new Promise((resolve, reject) => {
      if (!factory) return reject(new Error("IndexedDB unavailable"));
      let settled = false;
      const request = factory.open(CACHE_DATABASE, 1);
      const fail = error => { if (!settled) { settled = true; clearTimeout(timer); reject(error); } };
      const timer = setTimeout(() => fail(new Error("IndexedDB open timed out")), 3000);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(CACHE_STORE)) request.result.createObjectStore(CACHE_STORE);
      };
      request.onerror = () => fail(request.error);
      request.onblocked = () => fail(new Error("IndexedDB upgrade blocked"));
      request.onsuccess = () => {
        if (settled) { request.result.close(); return; }
        settled = true; clearTimeout(timer);
        const db = request.result;
        db.onversionchange = () => { db.close(); opening = undefined; };
        resolve(db);
      };
    }).catch(error => { opening = undefined; unavailable = true; throw error; });
    return opening;
  };
  const transaction = async (mode, action) => {
    const db = await open();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(CACHE_STORE, mode);
      const request = action(tx.objectStore(CACHE_STORE));
      tx.oncomplete = () => resolve(request.result);
      tx.onabort = () => reject(tx.error || new Error("Cache transaction aborted"));
      tx.onerror = () => reject(tx.error || request.error);
    });
  };
  return {
    keys: () => transaction("readonly", store => store.getAllKeys()),
    getItem: key => transaction("readonly", store => store.get(key)),
    setItem: (key, value) => transaction("readwrite", store => store.put(value, key)),
    removeItem: key => transaction("readwrite", store => store.delete(key)),
  };
}
